import type { TFunction } from 'i18next';
import type { ComparisonFormat, ComparisonValue } from './profileComparisonModel';

const number = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 });

export function formatProfilePercent(value: number): string {
  return `${number.format(value)} %`;
}

export function formatProfileValue(
  value: ComparisonValue,
  format: ComparisonFormat,
  t: TFunction,
): string {
  if (value === null || value === '') return '—';
  if (format === 'percent') return formatProfilePercent(Number(value));
  if (format === 'number') return number.format(Number(value));
  if (format === 'boolean') {
    return t(`admin.dynamicPricing.profiles.values.${value ? 'yes' : 'no'}`);
  }
  if (format === 'time') {
    const [start, end] = String(value).split('|');
    return start && end ? `${start.slice(0, 5)}–${end.slice(0, 5)}` : '—';
  }
  return t(`admin.dynamicPricing.profiles.values.${value}`, { defaultValue: String(value) });
}
